export default __webpack_public_path__ + "static/media/denise-artworkinfo4.0e1104ab.jpeg";